import React from "react";
import { Switch, Route } from "react-router-dom";

import ClientAppointments from "./components/appointments/Appointments.jsx";
import ProtectedRoutes from "../routes/ProtectedRoutes.jsx";
import CommonDocumentsManagement from "../commons/documents/DocumentsManagement.jsx";
import Projects from "../serviceProvider/components/projects/Projects";
import tickets from "../serviceProvider/components/tickets/tickets.jsx";
import ChatPage from "../commons/Chats/Chat.jsx";
import Boardingtickets from "../serviceProvider/components/tickets/Boardingtickets.jsx";
import { UserContextProvider } from "../context/UserContext.jsx";
import Profile from "./components/profile/Profile.jsx";
// Kundenportal
import PortalOverview from "./components/portal/PortalOverview.jsx";
import PortalOffers from "./components/portal/PortalOffers.jsx";
import PortalOfferDetail from "./components/portal/PortalOfferDetail.jsx";
import PortalChangeOrder from "./components/portal/PortalChangeOrder.jsx";
import PortalInvoices from "./components/portal/PortalInvoices.jsx";
import PortalInvoiceDetail from "./components/portal/PortalInvoiceDetail.jsx";
import PortalDocuments from "./components/portal/PortalDocuments.jsx";
import PortalMessages from "./components/portal/PortalMessages.jsx";

const NormalUserAppUniversal = function (props) {
  return (
    <UserContextProvider>
      <Switch>
        <ProtectedRoutes path="/client" exact component={PortalOverview} />
        <ProtectedRoutes path="/client/dashboard" exact component={PortalOverview} />
        <ProtectedRoutes path="/client/offers" exact component={PortalOffers} />
        <ProtectedRoutes path="/client/offers/change-orders/:id" exact component={PortalChangeOrder} />
        <ProtectedRoutes path="/client/offers/:id" exact component={PortalOfferDetail} />
        <ProtectedRoutes path="/client/invoices" exact component={PortalInvoices} />
        <ProtectedRoutes path="/client/invoices/:id" exact component={PortalInvoiceDetail} />
        <ProtectedRoutes path="/client/documents" exact component={PortalDocuments} />
        <ProtectedRoutes path="/client/messages" exact component={PortalMessages} />
        <ProtectedRoutes path="/client/projects" exact component={Projects} />
        <ProtectedRoutes exact path="/client/chats" component={ChatPage} />
        <ProtectedRoutes exact path="/client/my-profile" component={Profile} />
        <ProtectedRoutes path="/client/tickets/:id" exact component={tickets} />
        <ProtectedRoutes path="/client/Boards" exact component={Boardingtickets} />
        <ProtectedRoutes path="/client/appointments" exact component={ClientAppointments} />
        <ProtectedRoutes path="/client/directory" exact component={CommonDocumentsManagement} />
      </Switch>
    </UserContextProvider>
  );
};

export default NormalUserAppUniversal;
